import type React from 'react'
import { Badge } from '~/elements'

const NEW_BADGE_DURATION_MS = 7 * 24 * 60 * 60 * 1000 // 7 days

// Add entries here - badge shows for 7 days after the date
export const newBadgeConfig: Record<string, Date> = {
  Billing: new Date('2025-11-24'),
  Conversations: new Date('2025-10-30'),
  'Knowledge Bases': new Date('2025-10-29'),
}

/**
 * @internal
 * Sidebar-specific variant of the design-system Badge.
 * This intentionally tweaks spacing/typography to better fit the AppSidebar UI
 * and is not meant to be reused elsewhere.
 *
 * Renders a "New" badge if the id exists in newBadgeConfig and is within 7 days.
 */
export const NewBadge: React.FC<{ id: string }> = ({ id }) => {
  const addedDate = newBadgeConfig[id]
  if (!addedDate) return null
  if (Date.now() - addedDate.getTime() >= NEW_BADGE_DURATION_MS) return null

  return (
    <Badge variant="secondary" color="blue" className="py-0 text-[10px] leading-4">
      New
    </Badge>
  )
}
